/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import CurrencyIcon from '../../../components/CurrencyIcon';

export const ItemLayout = ({ onClick, note, noteType, withHover, children }) => (
  <div className="my-2 mw-100">
    <div
      role={isBrowser ? 'none' : 'button'}
      tabIndex={-1}
      onKeyDown={isBrowser ? null : onClick}
      onClick={isBrowser ? null : onClick}
      className={`row bg-lighter rounded-extra py-3 px-xl-4 px-3 position-relative mx-100 mx-auto ${
        withHover ? 'hover-item' : ''
      }`}>
      {children.map((child, index) => (
        <div
          key={index}
          className={`col-md-${child.props?.col} col-${child?.props?.mobileCol || '6'} my-auto ${
            index > 0 && index < children.length - 1 ? 'd-md-block d-none' : ''
          } ${child.props?.isRight || child.props?.isright === 'true' ? 'ms-auto text-end' : ''}`}>
          {child}
        </div>
      ))}
    </div>
    {noteType && note && (
      <div
        className={`row bg-${noteType} text-light text-f6 rounded-extra pb-2 mx-100 mx-auto`}
        style={{ marginTop: '-1rem', paddingTop: '1.5rem' }}>
        <p className="text-center">{note}</p>
      </div>
    )}
  </div>
);

ItemLayout.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  note: PropTypes.string,
  noteType: PropTypes.string,
  withHover: PropTypes.bool,
};

ItemLayout.defaultProps = {
  note: null,
  noteType: null,
  withHover: true,
};

export const IconWithLabel = ({ icon, label, subLabel }) => (
  <div className="d-flex flex-row align-items-center">
    <CurrencyIcon currencyCode={icon} className="m-0 me-3" />
    <div>
      <b className="text-f5 text-dark">{label}</b>

      <p className="d-none d-md-block text-shadow text-f6">{subLabel}</p>
      <p className="d-block d-md-none text-shadow text-f6">{subLabel}</p>
    </div>
  </div>
);
IconWithLabel.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
};
IconWithLabel.defaultProps = {
  subLabel: null,
};
